<div [formGroup]="model" [ngClass]="getEditedClass(field)">
    @if(field.label) {
        <app-reactive-field-label
            [field]="field"
            [form]="form"
            [model]="model"
            [originalModel]="originalModel"
            [undoEnabled]="undoEnabled"
            [tourAnchorId]="fieldHelpTourAnchorId"
            [sectionName]="sectionName"
            [showFieldHelpButtons]="showFieldHelpButtons"
            (undoRequested)="undoField($event)">
        </app-reactive-field-label>
    }

    @switch (field.input.type) {
        @case (inputType.ONLY_TEXT) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.NUMERIC) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.TEXT) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.PASSWORD) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.TEXT_MASK) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.TWO_FIELDS_CONCAT) {
            <app-reactive-text-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-text-field>
        }

        @case (inputType.TEXTAREA) {
            <app-reactive-textarea-field
                [field]="field"
                [form]="form"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-textarea-field>
        }

        @case (inputType.DROPDOWN) {
            <app-reactive-select-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [filterInputParcelas]="filterInputParcelas"
                [describedById]="describedById"
                [isInvalid]="isInvalid"
                (lazyDropdownRequested)="requestLazyDropdownLoad($event)"
                (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
            </app-reactive-select-field>
        }

        @case (inputType.DROPDOWN_SEARCH) {
            <app-reactive-select-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [filterInputParcelas]="filterInputParcelas"
                [describedById]="describedById"
                [isInvalid]="isInvalid"
                (lazyDropdownRequested)="requestLazyDropdownLoad($event)"
                (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
            </app-reactive-select-field>
        }

        @case (inputType.MULTISELECT) {
            <app-reactive-select-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [filterInputParcelas]="filterInputParcelas"
                [describedById]="describedById"
                [isInvalid]="isInvalid"
                (lazyDropdownRequested)="requestLazyDropdownLoad($event)"
                (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
            </app-reactive-select-field>
        }

        @case (inputType.MULTISELECT_SEARCH) {
            <app-reactive-select-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [filterInputParcelas]="filterInputParcelas"
                [describedById]="describedById"
                [isInvalid]="isInvalid"
                (lazyDropdownRequested)="requestLazyDropdownLoad($event)"
                (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
            </app-reactive-select-field>
        }

        @case (inputType.SELECT_BUTTON) {
            <app-reactive-select-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [filterInputParcelas]="filterInputParcelas"
                [describedById]="describedById"
                [isInvalid]="isInvalid"
                (lazyDropdownRequested)="requestLazyDropdownLoad($event)"
                (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
            </app-reactive-select-field>
        }

        @case (inputType.CALENDAR) {
            <app-reactive-calendar-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-calendar-field>
        }

        @case (inputType.TIME) {
            <app-reactive-calendar-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-calendar-field>
        }

        @case (inputType.EMPTY) {
            <div></div>
        }

        @case (inputType.SWITCH) {
            <app-reactive-switch-field
                [field]="field"
                [model]="model"
                [isEditable]="isEditable()"
                [describedById]="describedById"
                [isInvalid]="isInvalid">
            </app-reactive-switch-field>
        }

        @case (inputType.REPEATABLE_GROUP) {
            <app-repeatable-group
                [field]="field"
                [model]="model"
                [form]="form"
                [isEditable]="isEditable()"
                [debug]="isRepeatableGroupDebugEnabled()">
            </app-repeatable-group>
        }

        @case (inputType.EXTERNAL) {
            <ng-template dynamic-container></ng-template>
        }

        @default {
            <input
                [hidden]="true"
                [formControlName]="field.name"
                placeholder="..."
                pInputText
                type="text"
                maxlength={{field.input.maxLength}} />
        }
    }


    @if (hasVisibleHelpText()) {
        <small [id]="getHelpTextId()" class="form-text text-muted d-block mt-1 reactive-help-text">
            {{ getHelpText() }}
        </small>
    }

    @if (hasVisibleFieldError()) {
        <small [id]="'field-error-' + field.name" class="p-error d-block mt-1" role="alert">
            {{ getFieldErrorMessage() }}
        </small>
    }

    @if (hasVisibleSpanishIdSuccess()) {
        <small class="text-success d-block mt-1">
            NIF/CIF válido.
        </small>
    }
</div>
